import React, {useContext} from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {deleteTruck, getHeavyMachineryPoints, getWorkers, removeHeavyMachineryPointById, removeWorker} from "../api";
import {Request} from "../utils";
import {Store} from "../state_store/provider";
import {HEAVY_MACHINE_POINT, WORKER} from "../state_store/actionType";


export default function MachineDelete(props) {
    const {open, onClose, onOK, data} = props
    const {dispatch} = useContext(Store)
    const onDelete = ()=>{
        const {id} = data.target.data

        Request(dispatch, removeHeavyMachineryPointById(id), onOK).then(error=>{
            if(!error){
                getHeavyMachineryPoints(data.target.siteId).then(res=>{
                    if(res.result === 0){
                        dispatch({type:HEAVY_MACHINE_POINT, payload:res.heavyMachineryPoints})
                    }
                })
            }
        })
    }

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"title"}>削除</div>
                    <div className={"subtitle"}>
                        選択している作業重機位置を削除します。よろしいですか？
                    </div>

                </div>
                <div className={"delete-dialog-footer row center"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >いいえ</Button>
                    <Button
                        onClick={onDelete}
                        type="primary" style={{backgroundColor:"#377EF3"}}>はい</Button>
                </div>
            </div>
        </Modal>
    );
};
